var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Debuggable {
  constructor() {
    __publicField(this, "$debuggingNs");
  }
  $warn(key, ...msg) {
    this.__debug("warn", key, ...msg);
  }
  $error(key, ...msg) {
    this.__debug("warn", key, ...msg);
  }
  $info(key, ...msg) {
    this.__debug("log", key, ...msg);
  }
  $debug(key, ...msg) {
    this.__debug("log", key, ...msg);
  }
  $debugMethod(ns) {
    this.$debuggingNs = ns;
  }
  $endDebug() {
    this.$debuggingNs = void 0;
  }
  __debug(type = "log", key, ...entries) {
    if (!window.DEBUG && !window.DEBUG_PLAIN)
      return;
    console[type](
      ...style(
        this.constructor.name,
        "font-weight: bold; text-decoration: underline;"
      ),
      ...this.$debuggingNs ? style(this.$debuggingNs, "font-weight: bold; color: green") : [],
      ...style(`[${key}]`, "color: blue"),
      ...entries
    );
  }
}
function style(text, css) {
  if (window.DEBUG_PLAIN) {
    return [text];
  }
  return [`%c${text}`, css];
}
export {
  Debuggable
};
